var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)},on:{"click":_vm.clicked}}),_c('form-servizio-clienti',{attrs:{"showPrivacy":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }